import type { Ref } from 'vue';
import { ref } from 'vue';

import { crossbeamApi } from '@/api';
import { BulkTeamAccessAuthorization } from '@/types/report_team_access';
import { Report, TrimmedReport } from '@/types/reports';

export default function useReportTeamMembers(
  report: Ref<Report | TrimmedReport>,
) {
  const teamMembers = ref<BulkTeamAccessAuthorization[]>([]);

  async function getTeamMembers() {
    const { data, error } = await crossbeamApi.POST(
      '/v0.1/reports/bulk-team-access',
      { body: { report_ids: [report.value.id] } },
    );
    if (error) throw error;
    teamMembers.value = data?.authorizations || [];
  }

  return { teamMembers, getTeamMembers };
}
